
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { ConfigState, Erg } from 'shared/state'
// import SelectControl from 'display/components/controls/Select.vue'
import { GlobalConfig } from 'display/config'

@Component({ components: {}})
export default class ThemeSelect extends Vue {

	@Prop() value!: string
	@Prop() label!: string
	@Prop() config!: ConfigState

	theme: string = ''
	invalidMessage: string = ''

	themeJSON() {
		return this.config.themeAsJSON()
	}

	changeTheme(newTheme) {

		this.theme = newTheme
		this.invalidMessage = ''
		this.config.changeTheme(this.theme)
			.catch(err => {
				this.invalidMessage = 'That theme does not exist.'
			})
	}

	get supportedThemes() {
		const supportedThemeFiles: string[] = this.config.vals.global.devMode ? ['Default', 'Biathlon'] : ['Default']
		Erg.supportedThemes.forEach(t => {
			if(t) { supportedThemeFiles.push(t.split('.')[0]) }
		})
		return supportedThemeFiles
	}

}
